import DataTransferObject from '@/Communication/DataTransferObject';
import ComponentManager from '@/Management/ComponentManager';
import MemberOfDTO from '@/Communication/MemberOfDTO';

export default class MemberOfsDTO extends DataTransferObject {

    public ReadRight: boolean;

    public CreateRight: boolean;

    public MemberOfs: Array<MemberOfDTO>;

    constructor() {
        super({ xmlProperties: ['ReadRight', 'CreateRight', 'MemberOfs'], xmlNamespace: 'RADFoundation.RoleAssignment' });

        this.ReadRight = this.defaultFromType('bool');
        this.CreateRight = this.defaultFromType('bool');
        this.MemberOfs = this.defaultFromType('array');
    }
}

ComponentManager.setModel('MemberOfsDTO', MemberOfsDTO, 'RADPresentation.HTMLClient.DefaultViewExtensions');